import { IconExplore, TextButton, Tooltip } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

import { useUser } from '~/portal/hooks/useUser'
import { SHUBApiDetails } from '~/shared/types/api'

interface ExploreButtonProps {
  exploreUrl?: string,
  SHUBApiDetails: SHUBApiDetails
}

export const ExploreButton = ({ exploreUrl, SHUBApiDetails }: ExploreButtonProps) => {
  const { t } = useTranslation()
  const { isLoggedIn, user } = useUser()

  if (!exploreUrl || user?.isExternal) {
    return null
  }

  return (
    <Tooltip
      content={isLoggedIn ? t('components.ui.apiViewer.explore.tooltip.userLoggedIn') : t('components.ui.apiViewer.explore.tooltip.userNotLoggedIn')}
      trigger="hover"
      defaultComp={
        <TextButton
          href={`${exploreUrl}/catalog?owner=${SHUBApiDetails?.orgName}&api=${SHUBApiDetails?.name}&version=${SHUBApiDetails?.version}`}
          target="_blank"
          rel="noreferrer"
          size="s"
          icon={<IconExplore />}
          className="sp-api-viewer-explore-button ml-0! duration-200 transition-colors hover:bg-(--sp-color-surface-inverse) dark:hover:bg-(--sp-color-surface-inverse) hover:text-(--sp-color-text-inverse) dark:hover:text-(--sp-color-text-inverse)"
        >
          {t('components.ui.apiViewer.explore.label')}
        </TextButton>
      }
      placement="bottom"
    />)
}